import React from 'react';
import Input from '../elements/Input';
import { Select } from '@react-pdf/renderer';
import { matter_types } from '../../data/fileOpening';

const CaseInfo = ({ formData, handleChange }) => {
  return (
    <div>
      <div className="grid md:grid-cols-2 gap-6 my-6">
        <Input
          label="Date"
          type="date"
          name="date"
          value={formData.date}
          onChange={handleChange}
        />
        {/* <Input
          label="File Ref Number (by accountant)"
          type="text"
          name="file_ref"
          placeholder="Enter file reference number"
          value={formData.file_ref}
          onChange={handleChange}
        /> */}
        <div>
          <label className='font-bold dark:text-white'>Matter Type</label>
          <Select
            name="matter_type"
            className="w-full h-12 border rounded-md p-2 bg-white dark:bg-gray-700 text-gray-800 dark:text-white border-gray-300 dark:border-gray-600 focus:outline-none focus:ring-2 focus:ring-blue-500 dark:focus:ring-blue-400"
            value={formData.matter_type}
            onChange={handleChange}>
            <option value="">Select matter type</option>
            {matter_types.map((type) => (
              <option key={type} value={type}>
                {type}
              </option>
            ))}
          </Select>
        </div>
      </div>
      <h2 className="text-xl font-semibold mb-2 border-b pb-1 text-gray-800 dark:text-white">Case Details</h2>
      <textarea name="case_details" className="w-full border rounded-md p-2 mb-6 bg-white dark:bg-gray-700 text-gray-800 dark:text-white border-gray-300 dark:border-gray-600 focus:outline-none focus:ring-2 focus:ring-blue-500 dark:focus:ring-blue-400 my-6" rows="3" placeholder="Enter case details..." value={formData.case_details} onChange={handleChange}></textarea>
    </div>
  );
};

export default CaseInfo;